import Repository from "./Repository";

const ADD_MENU = "add";
const DELETE_MENU = "delete";
const UPDATE_MENU = "update";
const GET_MENU = "get";

export default {
  getAllMenu() {
    return Repository.post(transformRoute(GET_MENU));
  },
  addOneMenu(payload) {
    return Repository.post(transformRoute(ADD_MENU), payload);
  },
  editOneMenu(payload) {
    return Repository.post(transformRoute(UPDATE_MENU), payload);
  },
  deleteOneMenu(payload) {
    return Repository.post(transformRoute(DELETE_MENU), payload);
  },
};

const transformRoute = (route) => {
  return `/menu/${route}`;
};
